// import React from 'react';

// ----------------------------------------------------------------------

// export default function useTitle(title: any){
//     const documentDefined = typeof document !== 'undefined';
//     const originalTitle: any = React.useRef(documentDefined ? document.title : null);
  
//     React.useEffect(() => {
//       if (!documentDefined) return;
  
//       if (document.title !== title) document.title = title;
  
//       return () => {
//         document.title = originalTitle.current;
//       };
//     }, []);
// }
import React, { useEffect, useState } from "react";

const useDocumentTitle = (title: string): [string, React.Dispatch<React.SetStateAction<string>>] => {
  const [document_title, setDocumentTitle] = useState(title);
   useEffect(() => {
    document.title = document_title; 
  },[document_title]);

  return [document_title, setDocumentTitle];
};

export {useDocumentTitle};




// const useTitle = title => {
//     const documentDefined = typeof document !== 'undefined';
//     const originalTitle = React.useRef(documentDefined ? document.title : null);
  
//     React.useEffect(() => {
//       if (!documentDefined) return;
  
//       if (document.title !== title) document.title = title;
  
//       return () => {
//         document.title = originalTitle.current;
//       };
//     }, []);
//   };